import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf, renderIfElse} from "../../../Shared";
import {BrideIconOutlineSvg, GroomIconOutlineSvg} from "../../../../components/Svgs/ParentIconSvg";

import {Button} from "antd";
import {renderEmptyHolderMember} from "../../../AppLocals/CatholicHousehold/functions/renderEmptyHolderMember";
import {
    DoubleValueItem,
    ParentMemberItemInfo
} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInfoGrid, ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {HeaderWithIconLine} from "../../../AppLocals/Templates/items/ListHeader";
import {useCatholicHouseholds} from "../../../AppLocals/CatholicHousehold/functions/useCatholicHouseholds";
import {notifyOnError} from "../../../AppLocals/factory/createErrorEvent";
import {IoCloseCircleOutline, IoWarning} from "react-icons/io5";
import CatholicHouseholdChangeLogs from "../containers/CatholicHouseholdChangeLogs";
import {showConfirmDialog} from "../../../AppLocals/factory/createConfirmDialog";
import {formatDate} from "../../../../helpers/datetimeHelpers";


export const CatholicHouseholdApproveForm = ({item, onCancel}) => {
    const t = useTranslate()
    const members = _.get(item, 'catholic_household_members', []);
    const householdFather = _.first(members.filter(e => e.id === _.get(item, 'household_father.id')))
    const householdMother = _.first(members.filter(e => e.id === _.get(item, 'household_mother.id')))
    const householdMotherMatrimony = _.find(_.get(householdMother, 'sacraments', []), {sacrament_type: 'matrimony'})
    const householdFatherMatrimony = _.find(_.get(householdFather, 'sacraments', []), {sacrament_type: 'matrimony'})
    const childrenMembers = members.filter(e => e?.relationship_type === 'CHILDREN');

    const onRefresh = () => {
        onCancel();
    }

    const onError = notifyOnError(t)

    const {onChangeStatus} = useCatholicHouseholds({
        owner_type: item?.owner_type,
        owner_id: item?.owner_id,
        notifyListeners: {
            onStatusChanged: onRefresh,
        },
    })

    return (
        <div className="flex flex-col gap-y-6">
            <div className="mt-6 text-center font-bold text-2xl text-primary uppercase tracking-widest">
                {t('approve catholic household')}
            </div>

            <CatholicHouseholdChangeLogs item={item}/>

            <div className="flex flex-col gap-1">
                <div className="font-bold text-xl text-color-000 tracking-wide">
                    {`${t('catholic household')} ${item?.title}`}
                </div>
                <DoubleValueItem
                    showIcon={true}
                    labelFirst="number"
                    valueFirst={item?.source_idcode}
                    labelSecond="belong to"
                    valueSecond={item?.parish?.fullname}
                />
                <ItemInformation showIcon={true} label="date of immigration"
                                 value={formatDate(item?.eff_date, 'DD/MM/YYYY')}
                                 className="text-sm"/>
            </div>
            <div className="flex flex-col">
                <HeaderWithIconLine
                    center={true}
                    lineColor="border-green-300"
                    renderTitle={() => (
                        <span className="font-semibold text-lg text-green-300 tracking-widest uppercase leading-tight">
                            {t('church marriage certificate')}
                        </span>
                    )}
                    className="mb-3 w-full"
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-center gap-2">
                            <GroomIconOutlineSvg size={18} className="text-blue-500"/>
                            <span className="font-semibold text-blue-600 capitalize leading-snug tracking-wider">
                                {t('the groom side')}
                            </span>
                        </div>
                        {renderIfElse(
                            householdFather,
                            <ParentMemberItemInfo item={householdFather}/>,
                            renderEmptyHolderMember("no data is available now", "household mother description")
                        )}
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-center gap-2">
                            <BrideIconOutlineSvg size={18} className="text-blue-500"/>
                            <span className="font-semibold text-blue-600 capitalize leading-snug tracking-wider">
                                {t('the bride side')}
                            </span>
                        </div>
                        {renderIfElse(
                            householdMother,
                            <ParentMemberItemInfo item={householdMother}/>,
                            renderEmptyHolderMember("no data is available now", "household mother description")
                        )}
                    </div>
                </div>
                {renderIf(
                    householdFatherMatrimony,
                    <div className="mt-7 mb-3 flex flex-col flex-center gap-2">
                        <div className="flex flex-col text-center leading-snug">
                            <div className="font-bold text-lg text-primary uppercase tracking-widest">
                                {t('the sacrament of matrimony was celebrated')}
                            </div>
                            <div className="space-x-1 tracking-wider">
                                {renderIf(
                                    !!householdFatherMatrimony?.eff_date,
                                    <React.Fragment>
                                        <span className="text-base text-color-300 italic lowercase">{t('date')}</span>
                                        <span className="font-medium text-base text-primary-700">
                                            {formatDate(householdFatherMatrimony?.eff_date, 'DD/MM/YYYY')}
                                        </span>
                                    </React.Fragment>
                                )}
                                {renderIf(
                                    !!householdFatherMatrimony?.parish_name,
                                    <React.Fragment>
                                        <span className="text-base text-color-300 italic lowercase">{t('in')}</span>
                                        <span className="font-medium text-base text-primary-700">
                                            {householdFatherMatrimony?.parish_name}
                                        </span>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                            <ItemInfoGrid center={true} label="presiding priest"
                                          value={householdFatherMatrimony?.officiant_name}
                                          className="text-sm"/>
                            <ItemInfoGrid center={true} label="marriage book no"
                                          value={householdFatherMatrimony?.source_idcode}
                                          className="text-sm"/>
                            <ItemInfoGrid center={true} label="marriage witnesses 1"
                                          value={householdFatherMatrimony?.participant_name}
                                          className="text-sm"/>
                            <ItemInfoGrid center={true} label="marriage witnesses 2"
                                          value={householdMotherMatrimony?.participant_name}
                                          className="text-sm"/>
                        </div>
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-1">
                <HeaderWithIconLine
                    center={true}
                    lineColor="border-color-50"
                    renderTitle={() => (
                        <span className="font-semibold text-color-300 tracking-widest uppercase leading-tight">
                  {t('contact information')}
              </span>
                    )}
                    className="mb-3 w-full"
                />
                <ItemInformation showIcon={true} label="contact name" value={item?.contact_name} className="text-sm"/>
                <DoubleValueItem
                    showIcon={true}
                    labelFirst="phone"
                    valueFirst={item?.contact_phone}
                    labelSecond={(item?.contact_phone2 && " - ") || ''}
                    valueSecond={item?.contact_phone2}
                    className="text-sm"
                />
                <ItemInformation showIcon={true} label="address" value={item?.contact_address} className="text-sm"/>
            </div>
            <div className="p-3 flex flex-center gap-6">
                <div
                    onClick={() => {
                        showConfirmDialog({
                            translate: t,
                            icon: <IoWarning className="anticon"/>,
                            title: 'reject household',
                            message: 'are you sure you want to reject this household',
                            onOk: () => {
                                onChangeStatus({status: -2}, {id: item?.id})
                            },
                        })
                    }}
                    style={{height: 28, padding: '0 10px', borderRadius: 6}}
                    className="flex flex-center bg-orange-100 hover:bg-orange-200 font-medium text-orange-600 cursor-pointer">
                    <IoCloseCircleOutline size={15} className="mr-1"/>
                    {t('reject')}
                </div>
                <div className="flex-1"/>
                <Button
                    type="primary"
                    onClick={() => {
                        onChangeStatus({status: 1}, {id: item?.id})
                    }}
                    className="button-rounded-lg no-border flex flex-center px-5">
                    {t('approve')}
                </Button>
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
              {t('close')}
          </span>
            </div>
            <div/>
        </div>
    )
}


